export default "__VITE_ASSET__B6g$Br9g__";